module.exports = __webpack_public_path__ + "static/media/newTeacher.9ca7e617.JPG";